
import React from "react";
import { Helmet } from "react-helmet-async";
import { useMovieContext } from "@/context";
import { useAuth } from "@/context/AuthContext";
import AppHeader from "@/components/page/AppHeader";
import MainContent from "@/components/page/MainContent";
import MovieDialogManager from "@/components/movie/MovieDialogManager";
import { useTabNavigation } from "@/hooks/useTabNavigation";
import { useViewMode } from "@/hooks/useViewMode";
import { useSearchFocus } from "@/hooks/useSearchFocus";
import { useOpenMovieDetails } from "@/hooks/useOpenMovieDetails";
import { useDebugMonitor } from "@/utils/debugHelpers";

const Index = () => {
  const { favoriteMovies, unseenDirectorMovies, planToWatchMovies } = useMovieContext();
  const { user } = useAuth();
  const { currentTab, transitionDirection, handleTabChange } = useTabNavigation();
  const { viewMode, handleViewModeChange } = useViewMode();
  const { focusSearchInput, registerSearchInput } = useSearchFocus();
  
  const openLibraryMovie = useOpenMovieDetails("library");

  // Enable debug monitoring in development
  useDebugMonitor();

  const isAuthenticated = !!user;

  return (
    <div className="min-h-screen flex flex-col">
      <Helmet>
        <title>ReelAtlas - Chart your cinematic treasures</title>
        <meta
          name="description"
          content="Discover and track your favorite movies with ReelAtlas - your personal cinematic atlas."
        />
      </Helmet>
      
      <AppHeader 
        currentTab={currentTab}
        viewMode={viewMode}
        onTabChange={handleTabChange}
        onViewModeChange={handleViewModeChange}
        registerSearchInput={registerSearchInput}
        onOpenMovieDetails={openLibraryMovie}
      />

      <MainContent 
        currentTab={currentTab}
        transitionDirection={transitionDirection}
        viewMode={viewMode}
        favoriteMovies={favoriteMovies}
        unseenDirectorMovies={unseenDirectorMovies}
        planToWatchMovies={planToWatchMovies}
        isAuthenticated={isAuthenticated}
        onTabChange={handleTabChange}
        onOpenMovieDetails={openLibraryMovie}
        onSearchFocus={focusSearchInput}
      />

      <MovieDialogManager />
    </div>
  );
};

export default Index;
